/**
 * HTML entity escaping to prevent XSS when inserting untrusted data into HTML.
 */
window.webcommerceEscapeHtml = function webcommerceEscapeHtml(str) {
	if (str == null) return "";
	return String(str)
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;")
		.replace(/'/g, "&#x27;");
};
